import { render } from "./favorPage.vue?vue&type=template&id=7dbc10ee&scoped=true"
import script from "./favorPage.vue?vue&type=script&lang=js"
export * from "./favorPage.vue?vue&type=script&lang=js"

import "./favorPage.vue?vue&type=style&index=0&id=7dbc10ee&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dbc10ee"]])

export default __exports__